import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import './Feedback.css';

const Feedback = () => {
  const [searchParams] = useSearchParams();
  const clientId = searchParams.get('client_id');
  const clientName = searchParams.get('name') || '';
  const clientEmail = searchParams.get('email') || '';
  
  const [rating, setRating] = useState(0);
  const [hoverRating, setHoverRating] = useState(0);
  const [assistedBy, setAssistedBy] = useState('');
  const [improvement, setImprovement] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const API_URL = process.env.REACT_APP_API_URL || 'https://skolify-backend.onrender.com';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    if (rating === 0) {
      setError('Please select a rating');
      return;
    }
    
    setSubmitting(true);
    
    try {
      const response = await fetch(`${API_URL}/api/feedback/submit`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          client_id: clientId,
          client_name: clientName,
          client_email: clientEmail,
          rating,
          assisted_by: assistedBy,
          improvement
        })
      });
      
      const data = await response.json();
      
      if (data.success) {
        setSubmitted(true);
      } else {
        setError(data.error || 'Failed to submit feedback');
      }
    } catch (err) {
      console.error('❌ Feedback error:', err);
      setError('Failed to submit feedback. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  if (submitted) {
    return (
      <div className="feedback-page">
        <div className="feedback-container">
          <div className="feedback-success">
            <div className="success-icon">✅</div>
            <h1>Thank You!</h1>
            <p>Your feedback has been submitted successfully.</p>
            <p className="success-message">We appreciate you taking the time to share your experience with Skolify.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="feedback-page">
      <div className="feedback-container">
        <div className="feedback-header">
          <h1>Your Application is Complete!</h1>
          <p>We'd love to hear about your experience with Skolify</p>
        </div>

        <form onSubmit={handleSubmit} className="feedback-form">
          {/* Rating */}
          <div className="feedback-section">
            <label className="feedback-label">How was your experience with Skolify?</label>
            <div className="star-rating">
              {[1, 2, 3, 4, 5].map(star => (
                <button
                  key={star}
                  type="button"
                  className={`star-btn ${star <= (hoverRating || rating) ? 'active' : ''}`}
                  onClick={() => setRating(star)}
                  onMouseEnter={() => setHoverRating(star)}
                  onMouseLeave={() => setHoverRating(0)}
                >
                  ★
                </button>
              ))}
            </div>
            <span className="rating-text">
              {rating === 0 ? 'Select a rating' : rating === 1 ? 'Poor' : rating === 2 ? 'Fair' : rating === 3 ? 'Good' : rating === 4 ? 'Very Good' : 'Excellent'}
            </span>
          </div>

          {/* Who Assisted */}
          <div className="feedback-section">
            <label className="feedback-label">Who assisted you with your application?</label>
            <input
              type="text"
              className="assisted-input"
              placeholder="Enter their name"
              value={assistedBy}
              onChange={(e) => setAssistedBy(e.target.value)}
            />
          </div>

          {/* Improvement */}
          <div className="feedback-section">
            <label className="feedback-label">What would you like us to change or improve?</label>
            <textarea
              className="improvement-textarea"
              rows="5"
              placeholder="Share your thoughts..."
              value={improvement}
              onChange={(e) => setImprovement(e.target.value)}
            />
          </div>

          {error && (
            <div className="error-message">{error}</div>
          )}

          <button type="submit" className="submit-btn" disabled={submitting}>
            {submitting ? 'Submitting...' : 'Submit Feedback'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Feedback;